import React, { cloneElement, useState } from "react";
import { useRef } from "react";
import { useMemo } from "react";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import useWindowDimensions from "../../hooks/useWindowsDimention";
import styled from "styled-components";
import PropTypes from "prop-types";
import "../sidebar/style.css";

const SIDEBAR_EXPANDED = "300px";
const SIDEBAR_COLLAPSED = "72px";

const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

const NavbarPaner = styled.div`
  flex: 1;
  position: fixed;
  top: 0;
  left: ${({ openedMenu }) => (openedMenu ? SIDEBAR_COLLAPSED : SIDEBAR_EXPANDED)};
  width: ${({ openedMenu }) =>
    openedMenu ? `calc(100% - ${SIDEBAR_COLLAPSED})` : `calc(100% - ${SIDEBAR_EXPANDED})`};
  height: 50px;
  z-index: 4;
  transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`;

const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const SidebarPaner = styled.div`
  width: ${({ openedMenu }) => (openedMenu ? SIDEBAR_COLLAPSED : SIDEBAR_EXPANDED)};
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 2;
  overflow: visible;
`;

const MenuController = styled.button`
  position: absolute;
  top: 12px;
  right: -14px;
  width: 28px;
  height: 28px;
  padding: 0;
  background-color: #e0f2f1;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #009688;
  cursor: pointer;
  z-index: 5;
  box-shadow: 0 4px 12px rgba(0, 150, 136, 0.2);
  transition: background 0.2s ease, transform 0.2s ease;

  &:hover {
    background: #009688;
    transform: scale(1.05);
  }

  &:hover .menu-controller-icon {
    color: #fff;
  }
`;

const ContaintOutlet = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: #f3f4f6;
  transition: padding 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow-x: hidden;
  z-index: 1;
  padding: ${({ openedMenu, minViewPort }) => {
    if (minViewPort) return "70px 12px 0 12px";
    return openedMenu
      ? `70px 12px 0 calc(${SIDEBAR_COLLAPSED} + 8px)`
      : `70px 12px 0 calc(${SIDEBAR_EXPANDED} + 8px)`;
  }};
`;

const SpliTemplateScreenCabinet = ({ children }) => {
  const [openedMenu, setOpenedMenu] = useState(false);
  const [minViewPort, setMinViewPort] = useState(false);

  const [navbar, sidebar, outlet] = children;

  const sidebarRef = useRef(null);

  const { width } = useWindowDimensions();
  const handleResize = () => {
    setOpenedMenu((v) => !v);
  };

  useMemo(() => {
    if (width <= 1024) {
      setMinViewPort(true);
      setOpenedMenu(true);
    } else {
      setMinViewPort(false);
      setOpenedMenu(false);
    }
  }, [width]);

  return (
    <Container>
      <SidebarPaner openedMenu={openedMenu} ref={sidebarRef} className="sidebar-panel">
        <MenuController type="button" onClick={handleResize} aria-label="Basculer le menu">
          {openedMenu ? (
            <AiOutlineArrowRight className="menu-controller-icon" />
          ) : (
            <AiOutlineArrowLeft className="menu-controller-icon" />
          )}
        </MenuController>
        {cloneElement(sidebar, { openedMenu })}
      </SidebarPaner>

      <BodyContainer>
        <NavbarPaner openedMenu={openedMenu} ref={sidebarRef}>
          {navbar}
        </NavbarPaner>

        <ContaintOutlet openedMenu={openedMenu} minViewPort={minViewPort}>
          {outlet}
        </ContaintOutlet>
      </BodyContainer>
    </Container>
  );
};

SpliTemplateScreenCabinet.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
};

export default SpliTemplateScreenCabinet;
